import React from "react";
import FaqContactHeader from "../components/Common/Header/FaqContactHeader";
import { PartnershipCard } from "../components/BrandPartnership/PartnershipCard";
import { Box, Grid, Typography } from "@mui/material";
import MHFooter from "../components/Layout/MHFooter";
import MHSubscribe from "../components/Layout/MHSubscribe";

type Props = {};

const OurFocusArea = (props: Props) => {
  return (
    <React.Fragment>
      <FaqContactHeader
        label="mission"
        title="Our Focus Area"
        textColor="white"
        imageSrc="https://res.cloudinary.com/mother-honestly/image/upload/v1672946054/FAQ_ulvkpc.png"
        imageMobSrc="https://res.cloudinary.com/mother-honestly/image/upload/v1672946054/FAQ-mob_kcwqmd.png"
        // Center Class attributes
        headerClassName="absolute items-center top-32 md:top-32 md:w-full w-[331px] text-center left-0 right-0 md:ml-auto md:mr-auto mx-auto"
        titleClassName="md:w-[688px] w-[331px] mx-auto"

        // Left Class attributes
        // headerClassName="absolute items-center top-32 md:top-40 lg:pl-10 lg:text-left text-center md:w-full w-[331px] text-center left-0 right-0 md:ml-auto md:mr-auto mx-auto"
      />

      <Box className="text-center mt-10 overflow-hidden">
        <Typography
          variant="caption"
          color="primary"
          fontSize={{ xs: "14px", sm: "14px" }}
          lineHeight={{ xs: "230%", sm: "102%" }}
          letterSpacing={"0.1em"}
          className="uppercase w-[335px] md:w-[105px]"
        >
          Where We Focus
        </Typography>

        <Typography
          variant="body1"
          color="primary"
          fontSize={{ xs: "16px", sm: "16px", md: "16px" }}
          lineHeight={{ xs: "180%", sm: "195%" }}
          letterSpacing={{ xs: "0.05em", sm: "0.06em" }}
          className=" w-[335px] md:w-[650px] lg:w-[846px] py-4 text-justify md:text-center mx-auto"
        >
          At Caring Africa, we are driving systemic change across the full
          spectrum of care, from childcare and aging to women's health and the
          care workforce. Our work builds the infrastructure, policies, and
          partnerships needed to make care a recognized pillar of Africa's
          economic and social development.
        </Typography>
      </Box>

      <Grid
        container
        spacing={0}
        className=" place-content-center mx-auto"
        justifyContent="center"
        width={{ xs: "95%", sm: "90%", md: "80%" }}
        my={2}
      >
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <PartnershipCard
            image="https://mh-resources-production.s3.us-west-1.amazonaws.com/addprosper2.jpg"
            title="Childcare"
            goto="childcare"
            content={`
                Together, we can transform the childcare landscape in Africa, creating a brighter future for our children and empowering families...
`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <PartnershipCard
            image="https://mh-resources-production.s3.us-west-1.amazonaws.com/addprosper4.jpg"
            title="Aging Care"
            goto="aging-care"
            content={`
                The journey of aging should be one of dignity and respect. By supporting Caring Africa, you contribute to a future where the elderly in...

`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <PartnershipCard
            image="https://mh-resources-production.s3.us-west-1.amazonaws.com/The+Link+Between+Caregiving+and+Health.jpg"
            title="Women's Health"
            goto="women-health"
            content={`
                At Caring Africa, we are committed to advocating for a care-centered approach to women’s health—one that integrates...

`}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6}>
          <PartnershipCard
            image="https://mh-resources-production.s3.us-west-1.amazonaws.com/The+Backbone+of+Society%2C+Yet+Invisible+in+the+Economy.jpg"
            title="Care Workforce"
            goto="care-workforce"
            content={`
                At Caring Africa, we are committed to transforming the care workforce into a recognized, professionalized, and dignified...

`}
          />
        </Grid>
        {/* <Grid item xs={12} sm={5} md={4} lg={4}>
          <PartnershipCard
            image="https://mh-resources-production.s3.us-west-1.amazonaws.com/prosper5.png"
            title="Women's Work"
            content="Develop and improve care infrastructure, making it a cornerstone for economic development and societal well-being."
          />
        </Grid>
        <Grid item xs={12} sm={5} md={4} lg={4}>
          <PartnershipCard
            image="https://mh-resources-production.s3.us-west-1.amazonaws.com/prosper6.png"
            title="Boys and Men"
            content="Work towards formalizing care work, ensuring fair compensation and working conditions, and elevating its status within the economy."
          />
        </Grid>
        <Grid item xs={12} sm={5} md={4} lg={4}>
          <PartnershipCard
            image="https://mh-resources-production.s3.us-west-1.amazonaws.com/prosper6.png"
            title="Care Economy"
            content="Work towards formalizing care work, ensuring fair compensation and working conditions, and elevating its status within the economy."
          />
        </Grid> */}
      </Grid>

      <MHSubscribe />

      <MHFooter />
    </React.Fragment>
  );
};

export default OurFocusArea;
